module.exports = __webpack_public_path__ + "img/dekstop.a2d5b277.png";